import { render, staticRenderFns } from "./PolygonDraw.vue?vue&type=template&id=4e80e050&scoped=true"
import script from "./PolygonDraw.vue?vue&type=script&lang=js"
export * from "./PolygonDraw.vue?vue&type=script&lang=js"
import style0 from "./PolygonDraw.vue?vue&type=style&index=0&id=4e80e050&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e80e050",
  null
  
)

export default component.exports